/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetCmsTableError = (data) => ({
  type: actionTypes.CMS_ERROR,
  errorField: data,
});

export const cmsTableError = (value) => (dispatch) => {
  dispatch(dispatchGetCmsTableError(value));
};

export const dispatchGetCMSTableDetails = (data) => ({
  type: actionTypes.GET_CMS_TABLE_DATA,
  rebateCMSSearchResult: data,
});
export const setUpdateCMSData = (value) => (dispatch) => {
  dispatch(dispatchGetCMSTableDetails(value));
};

export const dispatchGetCMSTableEditedData = (data) => ({
  type: actionTypes.GET_CMS_TABLE_EDITED_DATA,
  editedData: data,
});
export const setCMSEditedData = (value) => (dispatch) => {
  dispatch(dispatchGetCMSTableEditedData(value));
};

export const dispatchGetCMSExtraState = (data) => ({
  type: actionTypes.CMS_EXTRA_STATE,
  extraState: data,
});
export const setCMSExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetCMSExtraState(value));
};

export const dispatchViewHistoryforPlan = (values) => {
  return {
    planViewHistory: values,

    type: actionTypes.VIEW_HISTORY,
  };
};
export const setNewCmsRow = (payload) => {
  return {
    type: actionTypes.ADD_NEW_CMS_DATA,
    payload,
  };
};

export const setNewCmsMatRowData = (payload) => {
  return {
    type: actionTypes.SET_MAT_DRUG_LIST,
    payload,
  };
};

export const setSuccessResponse = (successRes) => {
  return {
    type: actionTypes.SET_MAT_DRUG_SUCCESS,
    successRes,
  };
};

export const resetMatDrugStore = () => {
  return {
    type: actionTypes.RESET_MAT_DRUG_STORE,
  };
};

export const addNewRowData = (payload, action) => {
  return (dispatch, getState) => {
    const dataList = action
      ? [...action]
      : [...getState().sharedState.CmsReducer.matDrugListFromStore];
    if (Array.isArray(payload) && payload && payload.length > 0) {
      dispatch(setNewCmsMatRowData(payload));
    } else {
      const temp = [...dataList];
      temp.unshift(payload);
      dispatch(setNewCmsMatRowData(temp));
    }
  };
};
export const updateCMSTableDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CMS_DATA, values)
    .then((response) => {
      if (response.status == '200') {
        dispatch(setSuccessResponse(response));
        dispatch(getCmsMatDrugsList());
      }
    })
    .catch((error) => {
      dispatch(getCmsMatDrugsList(error.response.data));
    });
};
export const viewHistoryPlans = (values) => (dispatch) => {
  return axios

    .post(`${serviceEndPoint.VIEW_HISTORY}`, values)

    .then((response) => {
      return dispatch(
        dispatchViewHistoryforPlan(response.data.responseAuditLogDetails)
      );
    })

    .catch((response) => {
      dispatch(dispatchViewHistoryforPlan(response));
    });
};

export const getCmsMatDrugsList = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_CMS_MAT_DRUGS_LIST)
    .then((response) => {
      let newData = response.data && response.data.data;
      if (response.data && response.data.data) {
        newData = newData.map((val, index) => {
          val.isRemovedFromList = false;
          val.addNewRow = false;
          val.addEdit = false;
          val.index = index;
          val.id = uuidv4();
          return val;
        });
        dispatch(setNewCmsMatRowData(newData));
      }
    })
    .catch(() => {
      dispatch(setNewCmsMatRowData({ error: 'API failed' }));
    });
};
export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_CMS,
  errorMessagesInRedux: data,
});
